export class VerifyEventRequest {
  verified: boolean;
}
